var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button-group',_vm._l((_vm.dateTypeDict),function(item){return _c('el-button',{key:item.value,attrs:{"type":_vm.timeType === item.value ? 'primary' : ''},on:{"click":function($event){return _vm.setDateType(item)}}},[_vm._v(_vm._s(item.label)+"\n\t")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }